import NewTariffPage from './NewTariffPage';

export default NewTariffPage;
